const initSentry = () => {
  console.log('sentry is disabled in the GDS');
};

export default initSentry;
